import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { questionAnswered, questionErrored } from 'actions/questionnaires';
import { Mode, DynamicUpdateAction } from 'common/questionnaires/types';
import BoxInputField from 'components/Common/Inputs/BoxInputField';
import dynamicUpdateProp from 'common/questionnaires/questionDataProp';
import { getTinErrorMessage, getTinFormatFromQuestions } from 'common/questionnaires/tinHelper';

const QuestionTinFields = ({ id, name, isForm, dynamicUpdate, mode, fieldLength, fieldSeperator, runValidation, dispatch, fields }) => {
  const [tin, setTin] = useState('');

  if (tin !== '' && dynamicUpdate && dynamicUpdate.conditionMet
     && (dynamicUpdate.action === DynamicUpdateAction.DisableAndClear || dynamicUpdate.action === DynamicUpdateAction.HideAndClear)) {
    setTin('');
  }

  const validateQuestion = () => {
    const requiredInput = fields.find(i => i.required === true);
    const isRequired = requiredInput !== undefined && requiredInput.required;
    const customError = getTinErrorMessage(tin, fieldLength, isRequired);
    const isValid = (!customError);

    if (isValid) {
      dispatch(questionAnswered({ id, answer: tin, mode, isForm, name }));
    } else if (runValidation && !isValid && (!dynamicUpdate || !dynamicUpdate.conditionMet)) {
      dispatch(questionErrored({ id, mode, isForm, customError }));
    } else {
      dispatch(questionAnswered({ id, answer: '', mode, isForm, name }));
    }
  };

  useEffect(() => {
    validateQuestion();
  }, [tin, runValidation, dynamicUpdate]);

  const disabled = (dynamicUpdate && dynamicUpdate.conditionMet && dynamicUpdate.action === DynamicUpdateAction.DisableAndClear);
  return (
    <div id={ id }>
      <BoxInputField id={ id } name={ name } className="tin-box" callback={ setTin } fieldLength={ fieldLength } disabled={ disabled } fieldSeperator={ fieldSeperator } />
    </div>
  );
};

QuestionTinFields.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  isForm: PropTypes.bool,
  dynamicUpdate: dynamicUpdateProp,
  mode: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  fieldLength: PropTypes.number,
  fieldSeperator: PropTypes.arrayOf(PropTypes.number),
  runValidation: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.shape({
    placeholder: PropTypes.string,
    required: PropTypes.bool
  })).isRequired,
};

QuestionTinFields.defaultProps = {
  isForm: false,
  dynamicUpdate: null,
  fieldLength: 9,
  fieldSeperator: [2, 4],
  runValidation: false,
  name: null,
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  const {
    app: { onlineConfig },
    formQuestionnaire: { runValidation, questions }
  } = state;

  const tinDisplayMode = getTinFormatFromQuestions(questions);

  return {
    mode: (onlineConfig && onlineConfig.preQualifyingQuestionnaireMode) ? onlineConfig.preQualifyingQuestionnaireMode : Mode.Crs,
    fieldSeperator: (tinDisplayMode && tinDisplayMode === 'EIN') ? [1] : [2, 4],
    runValidation
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionTinFields);
